import { render, staticRenderFns } from "./LocaleChooser.vue?vue&type=template&id=e334db66&scoped=true&"
import script from "./LocaleChooser.vue?vue&type=script&lang=js&"
export * from "./LocaleChooser.vue?vue&type=script&lang=js&"
import style0 from "./LocaleChooser.vue?vue&type=style&index=0&id=e334db66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e334db66",
  null
  
)

export default component.exports